import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { NewDefaultTaskModal } from "defaultTask/New/NewDefaultTaskModal";
import { formatDeadline } from "userTask/beforeShowLabelHelper";

const DefaultTaskListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.DefaultTaskListFrontModel>();
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <NewDefaultTaskModal
        isOpen={isNewModalOpen}
        onClose={() => setIsNewModalOpen(false)}
      />
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet="defaultTasks_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={window.CoreApi.UserTaskTemplate.Paginated}
        getId={item => item.userTaskTemplateId}
        onNew={() => setIsNewModalOpen(true)}
        layout={{
          type: "table",
          columns: [
            {
              header: RESX.Message.Subject,
              render: item => <a href={routes.userTaskTemplate_Detail(item.userTaskTemplateId).absolute}>{item.title}</a>,
              key: "subject"
            },
            {
              header: RESX.Message.Deadline,
              render: item => <div>{formatDeadline(item.deadlineType, item.deadlineOffsetInDays)}</div>,
              key: "deadline"
            },
          ]
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
};


export default DefaultTaskListApp;